import React, { createContext, useState, useContext, useEffect } from 'react';
import Cookies from 'js-cookie';

const ServerContext = createContext();

export function ServerProvider({ children }) {
  // 从 cookie 中获取保存的服务器地址，如果没有则使用默认值
  const [serverUrl, setServerUrl] = useState(() => {
    const savedUrl = Cookies.get('serverUrl');
    return savedUrl || 'https://api.fbl.9estu.com';
  });

  // 从 cookie 中获取调试模式状态
  const [isDebugMode, setIsDebugMode] = useState(() => {
    const savedDebugMode = Cookies.get('debugMode');
    return savedDebugMode === 'true';
  });

  // 当 serverUrl 改变时，保存到 cookie 中
  useEffect(() => {
    Cookies.set('serverUrl', serverUrl, { expires: 365 }); // 保存一年
  }, [serverUrl]);

  // 当调试模式改变时，保存到 cookie 中
  useEffect(() => {
    Cookies.set('debugMode', isDebugMode.toString(), { expires: 365 }); // 保存一年
  }, [isDebugMode]);

  return (
    <ServerContext.Provider value={{ serverUrl, setServerUrl, isDebugMode, setIsDebugMode }}>
      {children}
    </ServerContext.Provider>
  );
}

export function useServer() {
  const context = useContext(ServerContext);
  if (!context) {
    throw new Error('useServer must be used within a ServerProvider');
  }
  return context;
} 